//  For each product on the page
document.querySelectorAll('.product').forEach(section => {

    const product = JSON.parse(section.querySelector(".productJSON").textContent);
    let activeVariant = JSON.parse(section.querySelector(".activeVariantJSON").textContent);
    let quantity = 1;

    // product has subscription
    const hasSubscription = product.selling_plan_groups.length > 0;


    // during dev mode, set the active variant to the window so it can be accessed in the console
    if (Shopify.theme.role === "development") {
        window.product = product;
        window.activeVariant = activeVariant;
    }

    /************
     Product Swiper
     ************/

        // if single image instead of swiper, don't load
    let swiperExists = false;
    let multipleSwipers = false;
    let productSwiper;
    if (!section.querySelector('.productVisualSingle')) {

        // if multiple swiper elements for variants
        if (section.querySelector('.productVisualAlt')) {
            // mark this for image change
            multipleSwipers = true;
            section.querySelector('.productVisualAlt').querySelectorAll('.productVisualSwiper').forEach(swiper => {
                // each gets a swiper
                const variantSwiper = new Swiper(swiper, {
                    slidesPerView: 1,
                    spaceBetween: 20,
                    autoHeight: true,
                });

                // change slide on thumbnail click
                swiper.nextElementSibling?.querySelectorAll(".productVisualThumbsSlide")?.forEach(element => {
                    element.addEventListener("click", function () {
                        // change slide
                        variantSwiper.slideTo(this.dataset.index - 1);
                    });
                });
            })
        } else {
            // mark these
            swiperExists = true;

            productSwiper = new Swiper(section.querySelector(".productVisualSwiper"), {
                slidesPerView: 1,
                spaceBetween: 20,
                autoHeight: true,
                on: {
                    slideChange: function () {
                        if (!section.querySelector(".productVisualSwiperSlide")) {
                            return;
                        }

                        // pause all videos
                        section.querySelectorAll(".productVisualSwiperSlide video").forEach(element => {
                            element.pause();
                        });
                    }
                }
            });

            // play video on slide play click
            section.querySelectorAll(".productVisualSwiperSlide")?.forEach(element => {
                element.addEventListener("click", function () {
                    // get video
                    const video = this.closest(".productVisualSwiperSlide").querySelector("video");

                    if (!video) {
                        return;
                    }

                    // remove play button if it hasn't already been removed
                    this.querySelector(".productVisualSwiperSlidePlay")?.remove();

                    // show controls
                    video.controls = true;

                    // play video
                    video.play();
                });
            });

            // change slide on thumbnail click
            section.querySelectorAll(".productVisualThumbsSlide")?.forEach(element => {
                element.addEventListener("click", function () {
                    // change slide
                    productSwiper.slideTo(this.dataset.index - 1);
                });
            });
        }
    }

    /**************
     Scarcity popups
     ***************/

    if (section.querySelector('.productVisualScarcity')) {
        // gather items and number
        const viewing = section.querySelectorAll('.productVisualScarcityViewing');
        const viewingPool = viewing.length;
        const adds = section.querySelectorAll('.productVisualScarcityAdd');
        const addsPool = adds.length;

        // load random popups, keep track in session storage to show other randoms
        setTimeout(() => {
            // show random viewing item that has not been seen this session, if all have been reused, reset
            let usedViews = JSON.parse(sessionStorage.getItem('views')) || [];
            if (usedViews.length === viewingPool) usedViews = [];
            let usedAdds = JSON.parse(sessionStorage.getItem('adds')) || [];
            if (usedAdds.length === addsPool) usedAdds = [];

            const viewIndex = randomNumber(viewingPool, usedViews);
            usedViews.push(viewIndex);
            viewing[viewIndex].classList.add('active');

            setTimeout(() => {
                // hide viewing and show random add items that has not been seen this session
                viewing[viewIndex].classList.remove('active');
                const addsIndex = randomNumber(addsPool, usedAdds);
                usedAdds.push(addsIndex);

                // add index counts to session storage
                sessionStorage.setItem('views', JSON.stringify(usedViews));
                sessionStorage.setItem('adds', JSON.stringify(usedAdds));

                // delay on showing second popup
                setTimeout(() => {
                    adds[addsIndex].classList.add('active');
                    setTimeout(() => {
                        // hide adds
                        adds[addsIndex].classList.remove('active');
                    }, 3000);
                }, 2000)
            }, 3000);
        }, 5000);

        function randomNumber(maxValue, usedNums) {
            let index = Math.floor(Math.random() * maxValue);
            if (usedNums.includes(index)) {
                for (let i = 0; i < maxValue; i++) {
                    if (!usedNums.includes(i)) {
                        index = i;
                        break;
                    }
                }
            }
            return index;
        }
    }

    /**************
     Update Product
     ***************/

    function isSubscription() {
        return !!section.querySelector(`.productSellingOptionInput[value="sub"]:checked`);
    }

    function currentSellingPlan() {
        return parseInt(section.querySelector('.productSellingOptionPlan').value);
    }

    // update active variant on input changes
    section.querySelectorAll("input, select").forEach(function (element) {
        element.addEventListener("change", function () {

            // check for single image layout and variant images
            if (element.classList.contains('imageSwap')) {
                // swap active images
                section.querySelector('.productVisualSingle.active')?.classList.remove('active');
                section.querySelector(`.productVisualSingle[data-value="${element.value}"]`)?.classList.add('active');
            }

            updateProduct().catch(e => console.error(e));
        });
    })

    async function updateProduct() {
        // Find the active variant
        if (product.variants.length === 1) {
            // default fallback
            activeVariant = product.variants[0];
        } else {
            // collect options from inputs
            let options = [];
            section.querySelectorAll(`.productOptionsValues`).forEach(group => {
                if (group.querySelector(`input:checked`)) {
                    options.push(group.querySelector(`input:checked`).value);
                }
            });

            // find new variant based on the options
            activeVariant = product.variants.find((variant) => {
                return JSON.stringify(variant.options) === JSON.stringify(options)
            });
        }

        // check if variant wasn't found
        if (!activeVariant) {
            section.querySelector(".productATC").disabled = true;
            section.querySelector(".productATCText").textContent = "Not Available";
            return;
        }

        /**************
         Variant Image
         ***************/

        if (activeVariant.featured_image && swiperExists) {
            // change active slide
            productSwiper.slideTo(activeVariant.featured_image.position - 1);
        }

        // swap swipers if available
        if (multipleSwipers) {
            section.querySelectorAll('.productVisualAltItem').forEach(swiper => {
                const id = section.querySelector('.productOptionsValuesLabelInput:checked')?.dataset.id || null
                if (id) {
                    id === swiper.dataset.id
                        ? swiper.classList.add('active') : swiper.classList.remove('active');
                }
            })
        }

        /**************
         Price
         ***************/

        // if there's a subscription we need to update both prices
        if (hasSubscription) {
            // Select both sets of elements at once
            const compares = section.querySelectorAll(".productSellingOptionHeaderPriceCompare");
            const reals = section.querySelectorAll(".productSellingOptionHeaderPriceReal");

            // Destructure them for clarity, otp comes first on DOM
            const [oneTimeCompare, subCompare] = compares;
            const [oneTimeReal, subReal] = reals;

            const allocationPrice = activeVariant.selling_plan_allocations[0].price;

            // Update subscription prices
            if (activeVariant.price > allocationPrice) {
                subCompare.textContent = price(activeVariant.price);
            }
            subReal.textContent = price(allocationPrice);

            // Update one-time purchase prices
            if (activeVariant.compare_at_price > activeVariant.price) {
                oneTimeCompare.textContent = price(activeVariant.compare_at_price);
            }
            oneTimeReal.textContent = price(activeVariant.price);

        } else {
            // Non-subscription scenario
            const compareEl = section.querySelector(".productSellingOptionHeaderPriceCompare");
            const realEl = section.querySelector(".productSellingOptionHeaderPriceReal");

            // check that the OTC is included
            if (realEl) {
                if (activeVariant.compare_at_price > activeVariant.price) {
                    compareEl.textContent = price(activeVariant.compare_at_price);
                }
                realEl.textContent = price(activeVariant.price);
            }
        }

        /**************
         ATC Enable/Disable
         ***************/

        // check if the variant is in stock
        if (section.querySelector(".productATC").dataset.text) {
            section.querySelector(".productATCText").textContent = section.querySelector(".productATC").dataset.text;
        } else {
            if (activeVariant.available) {
                section.querySelector(".productATC").disabled = false;
                section.querySelector(".productATCText").textContent = "Add To Cart";
            } else {
                section.querySelector(".productATC").disabled = true;
                section.querySelector(".productATCText").textContent = "Sold Out";
            }
        }

        // update url with variant id so the selected options are maintained on refresh
        let url = new URL(window.location.href);
        url.searchParams.set("variant", activeVariant.id);
        window.history.replaceState({}, "", url);
    }

    // on load, update the product
    // this accomplishes loading the correct variant image and price on page load
    updateProduct().catch(e => console.error(e));

    /**************
     Product Quantity
     ***************/

    // minus
    section.querySelector(".productQuantityControlsBtn.minus")?.addEventListener("click", function () {
        if (quantity === 1) {
            return;
        }
        quantity--;
        section.querySelector(".productQuantityControlsValue").textContent = quantity;
        updateProduct().catch(e => console.error(e));
    });

    // plus
    section.querySelector(".productQuantityControlsBtn.plus")?.addEventListener("click", function () {
        quantity++;
        section.querySelector(".productQuantityControlsValue").textContent = quantity;
        updateProduct().catch(e => console.error(e));
    });


    /**************
     Product ATC
     ***************/

    async function addToCart() {

        // add loading animation to both buttons
        section.querySelector(".productATC").classList.add("loading");

        let formData = {
            items: [{
                quantity: quantity,
                id: activeVariant.id,
            }]
        };

        // check for selling plan
        if (isSubscription()) {
            formData.items[0].selling_plan = currentSellingPlan();
        }

        // add product
        await addProduct(formData);

        // remove loading animation
        section.querySelector(".productATC").classList.remove("loading");

        // open cart
        await openCart();
    }

    section.querySelector('.productATC').addEventListener("click", addToCart);

});